import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import Actions from './account-template-actions';
import RefData from '../../ref-data';

const initialState = Immutable({
  isFetching: false,
  byId:       {},
  lastQuery:  {
    status:       RefData.Enum.STATUS.CAMPAIGNOBJECT.TEMPLATE,
    sort:         'lastUpdated',
    order:        'desc',
    searchFilter: '',
    offset:       0,
    max:          50,
  },
});

const reducer = createReducer(on => {
  on(Actions.fetch, state => state.set('isFetching', true));
  on(Actions.fetchFailure, state => state.set('isFetching', false));
  on(Actions.fetchSuccess, (state, { accountTemplates }) => {
    const _existing = _.clone(state.byId);
    const byId = _.reduce(
      accountTemplates,
      (acc, template) => {
        acc[template.id] = template;
        return acc;
      },
      _existing
    );
    return state.merge({ isFetching: false, byId });
  });

  on(Actions.clearAccountTemplates, state => state.set('byId', initialState.byId));
}, initialState);

export default reducer;
